import * as types from './mutations-types'

const mutations = {
  [types.SET_ACTIVE_MENU_INDEX] (state, activeMenuIndex) {
    state.activeMenuIndex = activeMenuIndex
  },
  [types.SET_USER_ACTIVE_MENU_INDEX] (state, userActiveMenuIndex) {
    state.userActiveMenuIndex = userActiveMenuIndex
  },
  [types.SET_MESSAGE_NUMBER] (state, messageNumber) {
    state.messageNumber = messageNumber
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js